module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.solo) ? _c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v("Please choose a profession")]) : _vm._e(), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "autocomplete": "",
      "label": "Select a profession",
      "item-text": "name",
      "item-value": "id",
      "return-object": "",
      "items": _vm.professions,
      "solo": _vm.solo,
      "clearable": "",
      "loading": _vm.request.loading
    },
    on: {
      "click:clear": function($event) {
        return _vm.$emit("clear")
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce8b6eda","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickers/ProfessionPicker.vue
// module id = 1523
// module chunks = 9